import { render } from "./PurchaseQualityDetail.vue?vue&type=template&id=62c1417e&scoped=true"
import script from "./PurchaseQualityDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseQualityDetail.vue?vue&type=script&lang=js"

import "./PurchaseQualityDetail.vue?vue&type=style&index=0&id=62c1417e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c1417e"]])

export default __exports__